const pushNotificationsSchedule = {
  'push-notifications-schedule-breadcrumbs': 'Расписание',
  'push-notifications-schedule-filter-title': 'Фильтр расписания',
  'push-notifications-schedule-time-outdated': 'Выбранное время устарело',
  'push-notifications-schedule-id': 'ID Расписания',
};

export default pushNotificationsSchedule;
